<template>
    <div
        role="tabpanel"
        class="tab-pane active"
        id="basic_info"
    >
        <div class="basic_info">
            <div class="col-md-8 mb20">
                <div class="row">
                    <div class="col-md-12 form-group mb20">
                        <p
                            v-if="changeMessage"
                            class="text-success"
                        >
                            {{ changeMessage }}
                        </p>
                        <label>現在のEメールアドレス</label>
                        <p
                            v-if="emailChanged"
                            class="text-success"
                        >
                            メールアドレスの変更が完了しました
                        </p>
                        <div class="flex justify-content-between mb15 flex-wrap">
                            <div class="mail">{{ user.viewEmail }}</div>
                            <div class="mail-text">
                                <span @click="(change = !change), (select = 1)"
                                    >会員登録情報を変更する</span
                                >
                            </div>
                        </div>

                        <transition-group name="fade">
                            <div
                                key="0"
                                v-if="change"
                            >
                                <label for="change-email">Eメールアドレス変更</label>
                                <input
                                    id="change-email"
                                    v-model.number="select"
                                    value="1"
                                    name="change"
                                    type="radio"
                                />
                                <label for="change-pass">パスワード変更</label>
                                <input
                                    id="change-pass"
                                    v-model.number="select"
                                    value="2"
                                    name="change"
                                    type="radio"
                                />
                            </div>
                            <div
                                key="1"
                                v-if="change && select === 1"
                                class="col-md-12"
                            >
                                <div class="form-horizontal">
                                    <div class="form-group">
                                        <input
                                            placeholder="変更するEメールアドレスを入力してください"
                                            v-model="user.changeEmail"
                                            name="change_email"
                                            type="text"
                                            class="form-control"
                                        />
                                        <has-error
                                            field="change_email"
                                            :form="user.form"
                                        ></has-error>
                                    </div>
                                    <div class="form-group">
                                        <button
                                            @click="changeEmail"
                                            v-btn-loading="user.busy"
                                            class="btn btn-accent"
                                        >
                                            更新する
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div
                                key="2"
                                v-if="change && select === 2"
                                class="col-md-12"
                            >
                                <div class="form-horizontal">
                                    <div class="form-group">
                                        <input
                                            v-model="user.changePassword"
                                            name="change_password"
                                            type="password"
                                            class="form-control"
                                            placeholder="パスワードを入力してください"
                                        />
                                        <has-error
                                            field="change_password"
                                            :form="user.form"
                                        ></has-error>
                                    </div>
                                    <div class="form-group">
                                        <input
                                            v-model="user.changePasswordConfirmation"
                                            name="change_password_confirmation"
                                            type="password"
                                            class="form-control"
                                            placeholder="パスワードを再度入力してください"
                                        />
                                        <has-error
                                            field="change_password_confirmation"
                                            :form="user.form"
                                        ></has-error>
                                    </div>
                                    <div class="form-group">
                                        <button
                                            @click="changePassword"
                                            v-btn-loading="user.busy"
                                            class="btn btn-accent"
                                        >
                                            更新する
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </transition-group>

                        <p class="basic_info-text">
                            ※以下の情報は注文時のフォームに自動的に反映されます<br />*
                            は必須項目です
                        </p>
                    </div>
                    <div class="col-md-12 form-group">
                        <label>御社名</label>
                        <input
                            autofocus="autofocus"
                            v-model="user.company"
                            name="company"
                            type="text"
                            class="form-control"
                        />
                    </div>

                    <div class="col-md-6 form-group">
                        <label>氏(family name)*</label>
                        <input
                            required="required"
                            autofocus="autofocus"
                            v-model="user.familyName"
                            name="family_name"
                            type="text"
                            class="form-control"
                        />
                        <has-error
                            field="family_name"
                            :form="user.form"
                        ></has-error>
                    </div>
                    <div class="col-md-6 form-group">
                        <label>名(given name)*</label>
                        <input
                            required="required"
                            autofocus="autofocus"
                            v-model="user.firstName"
                            name="first_name"
                            type="text"
                            class="form-control"
                        />
                        <has-error
                            field="first_name"
                            :form="user.form"
                        ></has-error>
                    </div>
                    <div class="col-md-6 form-group">
                        <label>連絡先電話番号(ハイフンなし)*</label>
                        <input
                            required="required"
                            autofocus="autofocus"
                            v-model="user.tel"
                            name="tel"
                            type="text"
                            class="form-control"
                        />
                        <has-error
                            field="tel"
                            :form="user.form"
                        ></has-error>
                    </div>

                    <div class="col-md-12 form-group mb40">
                        <div
                            class="col-md-12 form-group"
                            v-if="message"
                        >
                            <p
                                class="alert alert-info"
                                style="font-weight: bold"
                            >
                                {{ message }}
                            </p>
                        </div>
                        <button
                            @click="send"
                            v-btn-loading="user.busy"
                            class="btn btn-primary"
                        >
                            ユーザー情報を更新する
                        </button>
                    </div>

                    <div class="col-md-12 form-group mb40">
                        <UserAddressForms
                            label="お客様住所"
                            :addressModel="user.userAddress"
                        />
                    </div>

                    <div class="col-md-12 form-group mb40">
                        <AddressForms
                            label="納品先住所"
                            @submit="addAddress"
                        />
                    </div>

                    <div class="col-md-12 form-group add_address">
                        <div
                            class="col-md-12 form-group"
                            v-if="deliveryAddressMessage"
                        >
                            <p
                                class="alert alert-info"
                                style="font-weight: bold"
                            >
                                {{ deliveryAddressMessage }}
                            </p>
                        </div>
                        <label class="add-addresstitle">登録納品先住所一覧</label>
                        <div
                            v-if="!isdeliveryAddress()"
                            class="form-control"
                            style="border: 0"
                        >
                            住所が登録されていません
                        </div>
                        <ul
                            class="address-list"
                            v-if="isdeliveryAddress()"
                        >
                            <li v-for="deliveryAddress in user.deliveryAddresses">
                                <div class="addressbox flex align-items-center">
                                    <div class="address-name col-xs-8 col-md-8">
                                        {{ deliveryAddress.allAddress }}
                                    </div>

                                    <div
                                        class="col-md-3 flex justify-content-center align-items-center"
                                    >
                                        <button
                                            class="btn btn-accent btn-address"
                                            style="z-index: 0"
                                            :class="{ active: deliveryAddress.default }"
                                            @click="changeDefaultAddress(deliveryAddress)"
                                        >
                                            <i
                                                class="fa fa-check"
                                                style="color: #090"
                                                v-if="deliveryAddress.default"
                                            ></i>
                                            この住所を使う
                                        </button>
                                        <button
                                            class="btn btn-accent btn-destroy"
                                            @click="deleteAddress(deliveryAddress.id)"
                                        >
                                            削除
                                        </button>
                                    </div>
                                </div>
                            </li>
                        </ul>

                        <overlay-loading :condition="() => this.busy || busy"></overlay-loading>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { HasError } from 'vform'
import User from '../../models/User'
import BtnLoading from '../../directives/BtnLoading.vue'
import linq from 'linq'
import UserDeliveryAddress from '../../models/UserDeliveryAddress'
import OverlayLoading from '../../components/Admin/OverlayLoading.vue'
import AddressForms from '../checkout/AddressForms'
import axios from 'axios'
import UserAddressForms from '../mypage/AddressForms'

export default {
    name: 'basic-info',

    props: {
        _user: {
            type: Object,
        },
        emailChanged: {
            type: Number,
        },
    },

    data() {
        return {
            user: new User(),
            message: null,
            change: false,
            changeMessage: '',
            select: 0,
            busy: false,
            address: '',
            addressMessage: '',
            deliveryAddressMessage: '',
        }
    },

    created() {
        this.user = new User(this._user)
        console.log(this.user)
    },

    methods: {
        async send() {
            this.message = null
            const { data } = await this.user.patch(`/api/mypage/user/${this.user.id}`)
            this.user = new User(data)
            this.message = '更新が完了しました'
        },

        async changeEmail() {
            this.changeMessage = null
            await this.user.post(`/api/mypage/user/change-email`)
            this.changeMessage = '確認用メールアドレスを送信しました。'
        },

        async changePassword() {
            this.changeMessage = null
            await this.user.post(`/api/mypage/user/change-password`)
            this.user.clearPassword()
            this.changeMessage = 'パスワードを変更しました'
        },

        async addAddress(address) {
            this.user.addDelivery(new UserDeliveryAddress({ ...address }))
        },

        async changeDefaultAddress(address) {
            const fn = async () => {
                this.deliveryAddressMessage = ''
                const { data } = await axios.patch(
                    `/api/mypage/user/delivery-address/${address.id}`
                )
                await this.$nextTick()
                this.user.deliveryAddresses = linq
                    .from(data)
                    .select((x) => new UserDeliveryAddress({ ...x }))
                    .toArray()
                this.deliveryAddressMessage = 'デフォルト納品先住所を変更しました'
            }
            this.loadFunc(fn)
        },

        async deleteAddress(addressId) {
            const result = window.confirm('住所を削除しますか？')
            if (!result) return
            this.deliveryAddressMessage = ''
            const fn = async () => {
                await axios.delete(`/api/mypage/user/delivery-address/${addressId}`)
                this.user.deliveryAddresses = linq
                    .from(this.user.deliveryAddresses)
                    .where((x) => x.id != addressId)
                    .toArray()
                this.deliveryAddressMessage = '登録住所を削除しました'
            }
            this.loadFunc(fn)
        },

        isdeliveryAddress() {
            if (
                linq.from(this.user.deliveryAddresses).any((x) => !x.id) ||
                this.user.deliveryAddresses.length == 0
            ) {
                return false
            }
            return true
        },

        searchAddress() {
            this.addressMessage = false
            if (!this.address) return (this.addressMessage = true)
            axios.get('api/zipcode/' + this.address).then((res) => {
                if (res.data.err) return (this.addressMessage = true)

                this.user.address = this.address + ' ' + res.data[0]['allAddress']
            })
        },

        async loadFunc(fn) {
            this.message = null
            this.busy = true
            try {
                await fn()
            } catch (e) {
                throw new Error(e)
            } finally {
                this.busy = false
            }
        },
    },

    components: {
        AddressForms,
        HasError,
        OverlayLoading,
        UserAddressForms,
    },

    directives: {
        BtnLoading,
    },
}
</script>

<style lang="scss" scoped>
#basic_info {
    .help-block {
        color: red;
    }
    label {
        font-weight: bold;
    }
    .mail {
        font-weight: bold;
        font-size: 20px;
        color: #b9b9b9;
    }
    .mail-text {
        text-decoration-line: underline;
        font-weight: bold;
        color: #c70303;
        cursor: pointer;
    }
    .basic_info-text {
        font-size: 15px;
        font-weight: bold;
        color: #717179;
    }

    .fade-enter-active,
    .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter,
    .fade-leave-to {
        opacity: 0;
    }

    .add-addresstitle {
        opacity: 0.6;
    }

    .form-group.add_address {
        border-top: 1px solid #eee;
        padding-top: 30px;
    }

    .address-list {
        border: 1px solid #e6e8e9;
        li {
            margin-bottom: 10px;
            &:first-child {
                margin-top: 10px;
            }
        }
        .addressbox {
            flex-wrap: wrap;
            .address-name {
                padding: 14.5px 25px;
                font-size: 14px;
                font-weight: 400;
                letter-spacing: 0.05em;
                margin: 0;
                line-height: 1.42857143;
                @media all and (-ms-high-contrast: none) {
                    width: 60%;
                }
            }
            button.active {
                background-color: transparent;
                color: #000;
                padding-left: 5px;
                padding-right: 10px;
            }
            .btn-destroy {
                z-index: 0;
                color: #fff;
                background-color: red;
                padding: 5px 8px;
                height: 30px;
                margin-left: 10px;
            }
        }
    }

    .btn-accent.white {
        color: #000;
        background-color: #fff;
        &:hover {
            color: #fff;
            background-color: #000;
        }
    }
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/components/mypage/BasicInfo.vue